import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import EditCustomer from '../CustomerManagement/EditCustomer';
import Events from '../../../utilities/EventEmitter';
import useUpdateOrRemoveQueryParams from '../../../routes/utils/useUpdateOrRemoveQueryParams';
import { SESSION_STORAGE_KEYS } from '../../../appConstants';

const ShowCustomerEditPopup = (props) => {
  const location = useLocation();
  const customerCodeParams = props.customerCode;
  const [customerCode, setCustomerCode] = useState(null);
  const updateOrRemoveQueryParams = useUpdateOrRemoveQueryParams();

  useEffect(() => {
    setCustomerCode(customerCodeParams);
  }, [customerCodeParams]);

  const handleClose = ({ pathName } = {}) => {
    setCustomerCode(null);
    if(pathName){
       Events.emit('RedirectToPage', null, pathName)
    }else{
      updateOrRemoveQueryParams({
        paramsToUpdate: {
          customerCode: null
        },
        shouldRemove: true,
        stateData: { closeOnRefresh: true }
      });
    }
  };

  const navigateToHolidaySettingTab = (pathName, activeModule) => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTIVE_SETTINGS_MODULE, activeModule);
    handleClose({pathName});
  };
  
  return customerCode && props.glEventHub ? (
    <EditCustomer
      customerCode={customerCode}
      activeTabLabel={location?.state?.activeTabLabel}
      handleClose={handleClose}
      open={true}
      glEventHub={props.glEventHub}
      openModule={navigateToHolidaySettingTab}
      isHighZIndexRequired={location?.state?.isHighZIndexRequired}
      isNotificationVisible={props.isNotificationVisible}
    />
  ) : null;
};

export default ShowCustomerEditPopup;
